import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SbeSmsApiService } from '../../../core/generated-api/sbe-sms/sbe-sms-api';
import type { SmsStoreEnterTokenResponseDto } from '../../../core/generated-api/sbe-sms/models';

@Injectable({ providedIn: 'root' })
export class SmsStoreApiService {
  private readonly api = inject(SbeSmsApiService);

  enterToken(): Promise<SmsStoreEnterTokenResponseDto> {
    return firstValueFrom(
      this.api.staffSmsStoreControllerEnterToken<SmsStoreEnterTokenResponseDto>(),
    );
  }
}
